import * as React from 'react';
import {  DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { TextBoxWithStaticPrefix } from './TextBoxWithStaticPrefix';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldState, useFieldApi } from 'informed';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';

interface ConfigFieldTextBoxProps {
    id: string;
    field: string;
    className: string;
    siteNumber: string;
    disabled?: boolean;
    validated: boolean;
    required: boolean;
    autoComplete?: string;
    itemId: ConfigurableDataItemIds;
}

export const ConfigFieldTextBoxStaticPrefix = (props: ConfigFieldTextBoxProps): JSX.Element => {
    const {
        id,
        field,
        className,
        siteNumber,
        disabled,
        validated,
        required,
        autoComplete,
        itemId,
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();

    const fieldApi = useFieldApi(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className}>
                <label htmlFor={id}>{item.displayText}</label>
                <TextBoxWithStaticPrefix
                    id={id}
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    type="text"
                    staticpart={siteNumber}
                    validate={ConfigFieldValidation(item, required, validated)}
                    autoComplete={autoComplete}
                    disabled={disabled} />
            </div>
        </Condition>
    </>
}
